'use client';

import { useEffect } from 'react';
import { initPosthog } from '@/lib/posthog-init';

/**
 * Initializes PostHog after hydration (see lib/posthog-init.ts for why it can't
 * run during the client bootstrap). Mounted before <PostHogPageView /> so this
 * effect runs first and the SDK is ready when the pageview is captured.
 */
export default function PostHogInit() {
  useEffect(() => {
    initPosthog();
  }, []);

  return null;
}
